// Infinite CSS marquee. Duplicates children for a seamless loop.
export function Marquee({ children, slow = false, className = "" }) {
  return (
    <div className={`marquee-mask overflow-hidden ${className}`}>
      <div className={`flex w-max ${slow ? "animate-marquee-slow" : "animate-marquee"}`}>
        <div className="flex shrink-0 items-center">{children}</div>
        <div className="flex shrink-0 items-center" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}

export default Marquee;
